































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

import ArrowIcon from 'mdi-vue/MenuRight';
import LogoutIcon from 'mdi-vue/Logout';
import Button from '@/components/Button.vue';

import auth, { User } from '@/libs/auth';

@Component({
  components: {
    ArrowIcon,
    LogoutIcon,
    Button,
  },
  computed: mapState(['user']),
})
export default class HeaderUser extends Vue {
  open = false;
  user!: {
    user: User;
  };

  $refs!: {
    container: HTMLDivElement;
  }

  close(e: Event) {
    if (!this.$refs.container.contains(e.target as Node) && this.open) {
      this.open = false;
      document.removeEventListener('click', this.close);
    }
  }

  openMenu() {
    if (!this.open) {
      this.open = true;
      setTimeout(() => document.addEventListener('click', this.close), 1);
    }
  }

  logout() {
    this.$cookies.remove('st', '/', 'bayarind.id');
    this.$cookies.remove('refresh_token', '/', window.location.hostname);
    window.location.href = `${origin}/login`;
    auth.clearUser();
  }
}
